import React from 'react';
import '../styles/button.css'
import { useState } from 'react';
import { Typewriter } from 'react-simple-typewriter';
const StyledButton = ({type,size,content,onClick})=>{
    const [isdisplayed,setDisplay] = useState(false)
return(
    <div onClick={onClick} className={`container${size === 'small' ? '-small':''}`} onAnimationEnd={()=>setDisplay(true)}>
    <div className={`corner top left ${type} thin t-l-radius`}></div>
    <div className={`corner top right ${type} thin t-r-radius`}></div>
    <div className="content" >
        <div className={`content-container ${type}-background`}>
        <span>{isdisplayed && type !== 'danger' ? <Typewriter words={[`${content}`]} loop={1}  typeSpeed={20}/> :content}</span>
        </div>
    </div>
    <div className={`corner bottom left ${type} thin b-l-radius`}></div>
    <div className={`corner bottom right ${type} thin b-r-radius`}></div>
</div>
)
}
export default StyledButton;